'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './group.routes.js';
import GrpCtxCtrl from './group.controller.js';
import GroupListCtrl from './list/list.controller.js';
import GroupViewCtrl from './view/view.controller.js';
import GroupReportsCtrl from './view/reports/reports.controller.js';
import GroupFormCtrl from './form/form.controller.js';
import GroupAttributesCtrl from './view/attributes/attributes.controller.js';
import GroupSettingsOverviewCtrl from './view/settings/overview.controller.js';
import loaderModule from '../../components/loader/loader.component.js';
import authModule from '../../components/auth/auth.module.js';
import grpTypeSvcModule from '../../components/services/grpType.service.js';

export default angular.module('georgeApp.group', [
  uiRouter,
  loaderModule,
  authModule,
  grpTypeSvcModule
])
  .config(routing)
  .controller('GrpCtxCtrl', GrpCtxCtrl)
  .controller('GroupListCtrl', GroupListCtrl)
  .controller('GroupViewCtrl', GroupViewCtrl)
  .controller('GroupReportsCtrl', GroupReportsCtrl)
  .controller('GroupFormCtrl', GroupFormCtrl)
  .controller('GroupAttributesCtrl', GroupAttributesCtrl)
  .controller('GroupSettingsOverviewCtrl', GroupSettingsOverviewCtrl)
  .name;
